import 'jquery-steps/demo/css/jquery.steps.css';
import 'jquery-confirm/css/jquery-confirm.css';
import '../../styles/index_oss.css';

import $ from 'jquery';
import './Plugins/jquery-steps/jquery.steps';

import {makeSelect} from './customSelect.js';
import './components/jquery-confirm';

import SimFactory from './SimFactory';
import {RenderRecaptcha, ShowRecaptchaPopup} from './Recaptcha';

// import './menu'
// import './menu_mobile'
import './burger-menu'
import '../shared/script';
import {defaultAlert, errorAlert, successAlert} from "./components/jquery-confirm";
import {OoredooIcon} from "../ods/V2/Components/OoredooIcon";
import {makeSpinner} from "../ods/V2/Components/Helpers";
import '../shared/ekyc/ekyc'

const simFactory = new SimFactory;
const _dir = $('html').attr('dir');
const isRtl = _dir.toLowerCase() === 'rtl';

const onUploadingFileFailed = (event, response) => {

    ShowRecaptchaPopup(response);

}

const generateEsimsEmailAndQr = (attempts = 0) => {
    const esimElements = $('[data-esim_action="register"]');
    if (!esimElements.length) {
        return;
    }
    let esims = {};
    let action = null;
    $.each(esimElements, function (idx, el) {
        if (!action) {
            action = $(el).data('esim_action_url');
        }
        esims[$(el).data('sim_order_id')] = {
            id: $(el).data('sim_order_id'),
            sim_secret: $(el).data('sim_secret'),
        };
    });
    const spinner = makeSpinner();
    esims = Object.values(esims);
    if (!esims.length) {
        return;
    }
    const alert = defaultAlert(`${spinner}<div>يرجى الانتظار حتى يتم الانتهاء من إعداد الشريحة</div><div style="margin-bottom: 10px;" class="esim-current-step-message">الخطوة 1 من 6</div>`, {
        // icon:'icon-failed-circle-colored',
        iconHtml: false,
        closeIcon: false,
        hideButtons: true,
    });

    const handleErrors = (response, isFailed = false) => {
        let message = 'عذراً، لا يمكن إتمام هذه العملية حالياً، يرجى تحديث الصفحة وإعادة المحاولة.';

        console.log('response', response, isFailed);

        if (isFailed === true) {
            // console.log('isFailed@error', response)
            if (typeof response.responseJSON !== 'undefined') {

                if (response.responseJSON.errors && Array.isArray(response.responseJSON.errors) && response.responseJSON.errors.length) {
                    message = '';
                    $.each(response.responseJSON.errors, function (idx, err) {
                        if (err.message && Array.isArray(err.message)) {
                            $.each(err.message, function (ix, ms) {
                                message = message + `<div>${ms}</div>`;
                            });
                        } else if (err.message && typeof err.message === 'string' && err.message.length) {
                            message = message + `<div>${err.message}</div>`;
                        }
                    });
                } else if (typeof response.responseJSON.message !== 'undefined') {
                    message = response.responseJSON.message;
                }
            } else if (typeof response.responseText !== 'undefined') {
                let reloadPage = false;
                let isProxyErr = false;
                if (response.responseText.indexOf('Proxy Error') !== -1) {
                    reloadPage = true;
                    isProxyErr = true;
                    message += ' (Proxy Error)';
                } else {
                    if (response.responseText.indexOf('Your support ID is') !== -1) {
                        reloadPage = true;
                    }
                    let resText = '<div>'
                        + response.responseText
                            .replaceAll(/html/g, 'htmlx')
                            .replaceAll('<br>', '__NL__')
                            .replaceAll('<br/>', '__NL__')
                            .replaceAll('<br />', '__NL__')
                        + '</div>';

                    resText = $(resText).text().replaceAll('__NL__', '<br>').substr(0, 200);
                    message += `<div class="red" style="max-height: 200px;overflow-x: hidden;overflow-y:auto;direction: ltr;text-align: left;" >${resText}</div>`;

                    // response.responseText.indexOf('Your support ID') !== -1
                }

                if (reloadPage) {

                    let _proxyRedirectAttempt = 0;
                    let _url = document.location.href;
                    if (_url.indexOf('_pr') !== -1) {
                        let params = _url.split('?')[1].split('&');
                        $.each(params, function (idx, inp) {
                            inp = inp.split('=');
                            if (typeof inp[0] !== 'undefined' && inp[0] === '_pr' && typeof inp[1] !== 'undefined') {
                                let inpVal = parseInt(inp[1], 10);
                                if (!isNaN(inpVal)) {
                                    _proxyRedirectAttempt = inpVal;
                                }
                            }
                        })
                    }

                    if (_proxyRedirectAttempt < 1) {
                        _proxyRedirectAttempt += 1;
                        if (_url.indexOf('?') === -1) {
                            _url += '?';
                        } else {
                            _url += '&';
                        }

                        _url += '_pr=' + _proxyRedirectAttempt;
                        if (isProxyErr) {
                            _url += '&prx=1';
                        } else {
                            _url += '&supid=1';
                        }

                        setTimeout(function () {
                            window.location.href = _url;
                        }, 1000);

                        return false;
                    }
                }

            }


        } else {

            if (response.errors && Array.isArray(response.errors) && response.errors.length) {
                message = '';

                $.each(response.errors, function (idx, err) {
                    if (err.message && Array.isArray(err.message)) {
                        $.each(err.message, function (ix, ms) {
                            message = message + `<div>${ms}</div>`;
                        });
                    } else if (err.message && typeof err.message === 'string' && err.message.length) {
                        message = message + `<div>${err.message}</div>`;
                    }
                });
            } else if (response.message) {
                message = response.message;
            }

        }
        const buttons = {
            close: {
                text: application.oss.translations.oss_form.close,
                btnClass: 'main-btn',
                action: function () {
                }
            },

        };
        if (attempts < 2) {
            buttons.retry = {
                text: 'إعادة المحاولة',
                btnClass: 'main-btn',
                action: function () {
                    generateEsimsEmailAndQr(attempts + 1);
                    // return false;
                }
            };
        }

        return errorAlert(message, {
            buttons: buttons
        });

        // console.log('message', message)
        // alert.close();


    }


    const triggerMobileAppEvent = (simData) => {
        console.log('tmae')
        let qrCodeData = {
            event: 'ooredoo_esim_qr',
            data: {
                image_url: simData.qr_code_url,
                qr_code: simData.qr_code,
            },
        };

        // console.log('qrCodeData', qrCodeData);
        qrCodeData = JSON.stringify(qrCodeData);
        try {
            // For Android
            if (window.Android && Android.onOoredooEsimQrCodeReceived) {
                window.Android.onOoredooEsimQrCodeReceived(qrCodeData);
            }

        } catch (e) {
            console.error('Android event failed', e);
        }
        try {
            // For iOS
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.onOoredooEsimQrCodeReceived) {
                window.webkit.messageHandlers.onOoredooEsimQrCodeReceived.postMessage(qrCodeData);
            }

        } catch (e) {
            console.error('iOS event failed', e);
        }

        try {
            if (window.Flutter) {
                window.Flutter.postMessage(qrCodeData);
            }
        } catch (e) {
            console.error('Flutter event failed', e);
        }

        try {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(qrCodeData);
            }
        } catch (e) {
            console.error('ReactNativeWebView event failed', e);
        }

        try {
            const jsEvent = document.createEvent('CustomEvent');
            if (jsEvent.initCustomEvent) {
                jsEvent.initCustomEvent('ooredoo_esim_qr', true, true, qrCodeData);
            } else if (jsEvent.initEvent) {
                jsEvent.initEvent('ooredoo_esim_qr', true, true, qrCodeData);
            }

            document.dispatchEvent(jsEvent);

        } catch (e) {
            console.error('JS DOC event failed', e);
        }
    }

    const executeEsimRequest = function (params = {}) {
        params.esims = esims;

        console.log('params',params)


        $.ajax({
            url: action,
            method: 'POST',
            data: params,
            dataType: 'json',
            beforeSend: function (request) {
                request.setRequestHeader('Xsrf-K', window.application.requestToken.key);
                request.setRequestHeader('Xsrf-V', window.application.requestToken.value);

            },
            success: function (response) {
                if (typeof response.next_step !== 'undefined' && typeof response.next_step.id !== 'undefined') {
                    alert.$content.find('.esim-current-step-message').html(response.next_step.message);
                    executeEsimRequest({
                        next_step: response.next_step.id,
                    });
                    return response;
                }
                if (response.errors.length) {
                    handleErrors(response);
                }

                const actionsQr = $('.ooredoo-payment-status--actions-esim_qr');

                $.each(response.sims, function (idx, simData) {
                    $('.ooredoo-payment-message--esim-success').css('display', '');
                    const cta = $(`[data-esim_action="register"][data-sim_id="${simData.id}"]`);
                    cta.attr('href', simData.qr_code_url);
                    cta.attr('disabled', false);
                    cta.removeClass('disabled');
                    cta.removeClass('is-disabled');

                    const imgWrapper = actionsQr.find(`.ooredoo-payment-status--esim_qr--img-wrapper[data-sim_id="${simData.id}"]`);
                    const img = `<img src="${simData.qr_code_url}" style="width: 80%;" />`;
                    imgWrapper.append(img);
                    imgWrapper.css('display', '');
                    actionsQr.css('display', '');

                    triggerMobileAppEvent(simData);

                });

                setTimeout(function () {
                    alert.close();
                }, 1000);

            },
            error: function (response) {
                let err = handleErrors(response, true);
                if (false === err) {
                    return;
                }
                setTimeout(function () {
                    alert.close();
                }, 500);
            },
        });

    }

    executeEsimRequest();

    // console.log('esims', esims)

}

const onStepChanged = (formWizard, currentIndex) => {
    $(formWizard).attr('data-current_index', currentIndex);
    window._formWizard = formWizard;

    if (currentIndex === 0) {
        $(formWizard).attr('data-current_order', 'first');
    } else if ($(formWizard).find('section').length - 1 === currentIndex) {
        $(formWizard).attr('data-current_order', 'last');
    }else{
        $(formWizard).attr('data-current_order', 'middle');

    }
}
(
    ($) => {
        $(document).ready(function () {

            generateEsimsEmailAndQr();

            $('body').on('input blur paste', '.phone-input,.numeric-input,.sim-search-wrapper .msisdn', function (e) {
                // $(this).val($(this).val().replace(/\D/g, ''))
            });

            $('body').on('input blur paste', '.customer-info [name="identity_id"]', function (e) {
                if ($(this).closest('.form-group__element-list').find('#identity_type').val() === 'id_card') {
                    $(this).val($(this).val().replace(/\D/g, ''))
                }
            });

            $('body').on('change', '.customer-info #identity_type', function (e) {
                const identity_id = $(this).closest('.form-group__element-list').find('[name="identity_id"]');
                identity_id.trigger('blur');
                if ($(this).val() === 'id_card') {
                    identity_id.attr('type', 'tel');
                } else {
                    identity_id.attr('type', 'text');
                }

            });

            let currentStepIndex = 0;
            let isSubmitting = false;

            let formWizard = $("#wizard");
            const formWizardSections = formWizard.find('section');
            formWizardSections.first().addClass('wizard-section-first')
            formWizardSections.last().addClass('wizard-section-last')

            const isEsimReplacementWizard = () => {
                return formWizard.data('wizard_type') == 'esim_replacement';
            }

            const isNewEsimWizard = () => {
                return formWizard.data('wizard_type') == 'esim_request';
            }

            const isDefaultSimWizard = () => {

                return formWizard.data('wizard_type') == 'default_sim_request';
            }

            if ($('body').find('#wizard .error-name').length) {
                setInterval(() => {
                    $('body').find('#wizard .error-name').toggleClass('error-name--animate');
                }, 1000)
            }


            let selectedCity = '';
            $("#track-sim-status").on('click', function (e) {
                e.preventDefault();
                const btn = $(this);
                const reqNum = $("#track-sim-status-id");
                reqNum.parent().find('.error-name').remove();
                if (!reqNum.val().length) {
                    reqNum.parent().append(`<div class="error-name">${application.oss.translations.oss_form.required_field}</div>`);
                    return false;
                }
                let text = btn.text();
                btn.html('<div class="loader"></div>');
                simFactory.trackSimStatus(reqNum.val())
                    .then((response) => {
                        btn.text(text)

                        let dom = $("body").find('.order-statuses');
                        if (typeof response.statuses_html !== 'undefined' && response.statuses_html) {
                            dom.after(response.statuses_html);
                            dom.remove();
                            dom = $("body").find('.order-statuses')
                        }
                        dom.addClass('display');
                        // dom.find('.res-item.active').removeClass('active');
                        // dom.find(`.res-item[data-status="${response.order.status}"]`).addClass('active');
                        // if (response.order.status == 6) {
                        //     dom.find('.res-item:not(.res-item-failed)').stop().hide('fast');
                        //     // dom.find('.res-item-failed').stop().show('fast');
                        //     dom.find(`.res-item[data-status="${response.order.status}"]`).stop().show('fast');
                        // } else {
                        //     dom.find('.res-item:not(.res-item-failed)').stop().show('fast');
                        //     dom.find('.res-item-failed').stop().hide('fast');
                        // }

                        if ($(window).height() <= 500) {
                            $('html,body').animate({
                                scrollTop: dom.offset().top - 100
                            }, 1500)
                        }

                    }).catch(() => {
                    btn.text(text);
                    $(".order-statuses").removeClass('display')
                })

            });

            const validateWizard = (currentIndex, newIndex = false) => {

                let hasErrors = false;
                const currentStep = $(this).find(`#wizard-p-${currentIndex}`);

                currentStep.find(".error-name").remove();
                const requiredElements = currentStep.find('[required]');
                const radios = currentStep.find('.radio-group');

                if (isDefaultSimWizard()) {

                    if (currentIndex === 0) {
                        let totalSims = currentStep.find('#total_sims').val();
                        if (!totalSims) {
                            totalSims = 1;
                        }
                        simFactory.initSims(totalSims);
                    } else if (currentIndex === 1) {
                        if (!simFactory.isValid()) {
                            hasErrors = true;
                        }
                    } else if (currentIndex === 2) {
                        if (!$('#recaptcha').find('#g-recaptcha-response').length || !$('#recaptcha').find('#g-recaptcha-response').val().length) {
                            // hasErrors = true;
                            $('.form-group__element-recaptcha').after(`<div class="error-name">${application.oss.translations.oss_form.required_field}</div>`);
                        }
                    }
                } else {
                    if (isNewEsimWizard()) {
                        if (currentIndex === 0) {
                            if (!simFactory.isValid()) {
                                hasErrors = true;
                            }
                        } else if (currentIndex === 1) {

                        }
                    }
                    if (currentStep.find('.g-recaptcha').length) {
                        if (!currentStep.find('.g-recaptcha').find('#g-recaptcha-response').length || !currentStep.find('.g-recaptcha').find('#g-recaptcha-response').val().length) {
                            hasErrors = true;
                            $('.form-group__element-recaptcha').after(`<div class="error-name">${application.oss.translations.oss_form.required_field}</div>`);
                        }
                    }
                }


                $.each(radios, function (index, el) {
                    if (!$(el).find('input[type="radio"]:checked').length) {
                        hasErrors = true;
                        $(el).find('.form-group__element').append(`<div class="error-name">${application.oss.translations.oss_form.required_field}</div>`);
                    }
                });


                $.each(requiredElements, function (index, el) {
                    if ($(el).hasClass('upload-btn-wrapper')) {
                        if (!$(el).find('.lego-files-preview input').length || !$(el).find('.lego-files-preview input').val().length) {
                            hasErrors = true;
                            $(el).parent().append(`<div class="error-name ">${application.oss.translations.oss_form.required_field}</div>`);
                        }
                    } else if ($(el).attr('type') == 'checkbox') {
                        if (!el.checked) {
                            hasErrors = true;
                            $(el).parents('.form-group__element').append(`<div class="error-name">${application.oss.translations.oss_form.required_field}</div>`);
                        }
                    } else if (!$(el).val() || !$(el).val().length) {
                        hasErrors = true;
                        $(el).parents('.form-group__element').append(`<div class="error-name">${application.oss.translations.oss_form.required_field}</div>`);
                    }
                });

                if (!hasErrors && typeof currentStep.data('validate_step_url') === 'string' && currentStep.data('validate_step_url').indexOf('http') === 0) {
                    formWizard.find('.wizard--loader').stop().fadeIn('fast');
                    return simFactory.validateStepRequest($('form#reserve-sim'), currentStep.data('validate_step_url'), {
                        currentStepIndex: currentIndex,
                        onFailed: () => {
                            formWizard.find('.wizard--loader').stop().fadeOut('fast');
                            // window.grecaptcha.reset();
                            $.each(currentStep.find('.g-recaptcha-manual'), function (idx, el) {
                                window.grecaptcha.reset($(el).data('grecaptcha_id'));
                            });
                        },
                        onSuccess: (response) => {
                            formWizard.find('.wizard--loader').stop().fadeOut('fast');
                            console.log('response', response)
                            if (typeof response.step_html !== 'undefined' && (typeof response.step_html === 'object' || Array.isArray(response.step_html))) {
                                $.each(response.step_html, function (idx, responseStep) {
                                    if (!responseStep.step_index) {
                                        return;
                                    }
                                    formWizard.find(`#wizard-p-${responseStep.step_index} .wizard-step-response-content`).html(responseStep.html);
                                })

                            }
                            $.each(currentStep.find('.g-recaptcha-manual'), function (idx, el) {
                                window.grecaptcha.reset($(el).data('grecaptcha_id'));
                            });
                        },

                    });

                }
                return !hasErrors;
            };

            const getEverythingReady = (currentIndex, priorIndex) => {

                const currentStep = $(this).find(`#wizard-p-${currentIndex}`);

                if (isDefaultSimWizard()) {
                    if (priorIndex === 0 && currentIndex === 1) {
                        simFactory.buildSimsFields(currentStep.find('#sims-fields'));
                    }

                    if (currentIndex === 1) {
                        const addressCity = $(this).find(`#wizard-p-0`).find('#address_city');
                        const city = window.application.oss.exhibitions[addressCity.val()];
                        const cityDeliveryMethods = city.delivery_methods || [];

                        const exhibitionEl = $(this).find(".choose-exhibition .custom-select");
                        currentStep.find('[name="delivery_method"]').unbind();
                        currentStep.find('[name="delivery_method"]').on('click', function (e) {
                            const _val = $(this).val();
                            if (_val === 'exhibition') {
                                $(".choose-exhibition").addClass('display');
                                exhibitionEl.prop('required', true);
                            } else {
                                $(".choose-exhibition").removeClass('display');
                                exhibitionEl.prop('required', false);
                            }

                            $.each($('.note-delivery-method'), function (_index, _el) {
                                if ($(_el).data('delivery_type') != _val) {
                                    $(_el).stop().slideUp('fast');
                                } else {
                                    $(_el).stop().slideDown('fast');
                                }
                            })

                            $(this).parents('.form-group__element').find(".error-name").remove();
                        });
                        currentStep.find('[name="payment_method_code"]').on('click', function (e) {
                            const _val = $(this).val();

                            $.each($('.note-payment-method'), function (_index, _el) {
                                if ($(_el).data('payment_method') != _val) {
                                    $(_el).stop().slideUp('fast');
                                } else {
                                    $(_el).stop().slideDown('fast');
                                }
                            })

                            $(this).parents('.form-group__element').find(".error-name").remove();
                        });

                        const deliveryMethods = currentStep.find('.sim-delivery .exhibition-item .select--type-radio .select-type');
                        deliveryMethods.css('display', 'none').removeClass('is-available');
                        $.each(deliveryMethods, function (idx, element) {
                            const dm = $(element).find('[name="delivery_method"]').val();
                            if (typeof cityDeliveryMethods[dm] !== 'undefined') {
                                $(element).css('display', '').addClass('is-available');
                            } else if (Array.isArray(cityDeliveryMethods) && cityDeliveryMethods.indexOf(dm) !== -1) {
                                $(element).css('display', '').addClass('is-available');
                            }
                        });
                        const availableDeliveryMethods = currentStep.find('.sim-delivery .exhibition-item .select--type-radio .select-type.is-available');

                        if (availableDeliveryMethods.length == 1) {
                            availableDeliveryMethods.find('[name="delivery_method"]').trigger('click');
                            availableDeliveryMethods.closest('.exhibitions-item-delivery-methods').css('display', 'none');
                            currentStep.find('.sim-delivery-title .sim-delivery-all-methods').css('display', 'none');
                            currentStep.find('.sim-delivery-title .sim-delivery-single-method').stop().fadeIn('fast');
                        } else {
                            availableDeliveryMethods.closest('.exhibitions-item-delivery-methods').css('display', '');
                            currentStep.find('.sim-delivery-title .sim-delivery-single-method').css('display', 'none');
                            currentStep.find('.sim-delivery-title .sim-delivery-all-methods').stop().fadeIn('fast');
                        }
                    } else if (currentIndex === 2) {
                        const selectedDeliveryMethod = formWizard.find('[name="delivery_method"]:checked').val();

                        const secondName = formWizard.find('#second_name');
                        const middleName = formWizard.find('#middle_name');
                        const addressArea = formWizard.find('#address_area');
                        const addressStreet = formWizard.find('#address_street');
                        const uploadBtnWrapper = formWizard.find('.upload-btn-wrapper');
                        const arr = [];
                        arr.push(secondName);
                        arr.push(middleName);
                        arr.push(addressArea);
                        arr.push(addressStreet);
                        arr.push(uploadBtnWrapper);
                        if (selectedDeliveryMethod === 'door_to_door') {
                            $.each(arr, function (idx, el) {
                                el.attr('required', true);
                                el.closest('.input-wrapper-requirable').css('display', '');
                            });
                        } else {

                            $.each(arr, function (idx, el) {
                                el.attr('required', false);
                                el.closest('.input-wrapper-requirable').css('display', 'none');
                            });
                        }

                    }
                } else {
                    if (isNewEsimWizard()) {
                        if (currentIndex === 0) {
                            const originalSelect = currentStep.find('.custom-select');
                            $.each(originalSelect, function (index, element) {
                                makeSelect($(element));
                            })
                            currentStep.on('change', '#address_city', function (e) {
                                let limit = 0;
                                if ($(this).val() && $(this).val().toString().length) {
                                    limit = 1;
                                }

                                simFactory.setCity($(this).val());
                                simFactory.resetSims();
                                simFactory.initSims(limit);

                                simFactory.buildSimsFields(currentStep.find('#sims-fields'));

                                const msisdnsWrapper = currentStep.find('.sims-fields-wrapper');
                                if (!limit) {
                                    msisdnsWrapper.stop().slideUp('fast');
                                } else {
                                    msisdnsWrapper.stop().slideDown('fast');
                                    const originalSelect = msisdnsWrapper.find(".custom-select");
                                    $.each(originalSelect, function (index, element) {
                                        makeSelect($(element));
                                    })

                                }
                            });

                        } else if (currentIndex === 1) {

                        }
                    }
                }

                if (currentStep.find('.g-recaptcha-manual').length) {
                    $.each(currentStep.find('.g-recaptcha-manual'), function (idx, el) {
                        const reviewRecaptchaWidgetId = RenderRecaptcha(el, function (response) {
                        });
                    });
                }

                currentStep.find('input.phone-input').attr('type', 'tel');

                const originalSelect = currentStep.find(".custom-select");

                $.each(originalSelect, function (index, element) {
                    makeSelect($(element));
                })

                $.each(currentStep.find('input[data-type="radio-btn"]'), function (i, el) {
                    if (!$(el).hasClass('initialized')) {
                        $(el).addClass('initialized');
                        $(el).addClass('radio-btn');
                        $(el).after('<span class="radio-check-mark"></span>');
                        $(el).parent().addClass('radio-btn-container')
                    }

                })


                //remove the header of wizard
                $('ul[role="tablist"]').css('display', 'none');
                const headers = $(this).find(`#wizard-h-${currentIndex}`);

                headers.remove();
                currentStep.css('height', 'auto');
                let bodyHeight = currentStep.height();
                let padding = currentStep.innerHeight() - bodyHeight;
                bodyHeight += padding;
                bodyHeight += 10;
                currentStep.after('<div class="clearfix"></div>');
                currentStep.parent().animate({minHeight: bodyHeight}, "slow");

            };

            const setWidth = () => {
                $.each($(formWizard).find('section'), function (index, section) {
                    let labelsWidth = 10;
                    const labels = $(section).find('.input-wrapper > label')
                    $.each(labels, function (jindex, label) {
                        $(label).css('width', 'auto')
                        // $(label).css('width', 'fit-content')
                        if ($(label).width() > labelsWidth) {
                            labelsWidth = $(label).width();
                        }
                    });

                    labels.css('width', labelsWidth);
                })

            }
            formWizard.steps({
                headerTag: ".wizard-header",
                bodyTag: "section",
                transitionEffect: "slideLeft",
                autoFocus: true,
                startIndex: 0,
                labels: {
                    // cancel: "Cancel",
                    // current: "current step:",
                    // pagination: "Pagination",
                    finish: `<button class="main-btn main-btn finish-btn" type="button">
<span>${application.oss.translations.oss_form.submit_form}</span></button>`,
                    next: `<button class="main-btn next-btn" type="button"><span> ${application.oss.translations.oss_form.next} </span></button>`,
                    previous: `<button type="button" class="main-btn prev-btn"><span>${application.oss.translations.oss_form.back}</span></button>`,
                    // loading: "Loading ..."
                },
                onInit: function (event, currentIndex) {
                    var _me = $(this);
                    onStepChanged(formWizard, 0)
                    currentStepIndex = currentIndex;
                    setWidth();
                    getEverythingReady(currentIndex);
                    $.each($(this).find('section'), function (i, sec) {
                        $(sec).attr('data-index', i)
                        $(sec).data('index', i)
                    });

                    const backBtn = _me.find('.prev-btn');
                    backBtn.on('click', function (e) {
                        if (currentStepIndex === 0) {
                            window.location.href = application.oss.urls.index;
                        }
                    });
                    if (isDefaultSimWizard()) {

                        const simDeliveryAddress = $('#sim-delivery__address');
                        const addressCity = $(this).find(`#wizard-p-0`).find('#address_city');
                        const exhibitions = _me.find('[name="delivery_exhibition"]');
                        exhibitions.on('change', function (e) {
                            const selectedExh = $(this).val();
                            const city = addressCity.val();
                            if (typeof application.oss.exhibitions[city] !== 'undefined' && typeof application.oss.exhibitions[city].exhibitions !== 'undefined' && Object.keys(application.oss.exhibitions[city].exhibitions).length) {
                                const cityExh = application.oss.exhibitions[city].exhibitions;
                                if (typeof cityExh[selectedExh] !== 'undefined' && typeof cityExh[selectedExh].address !== 'undefined') {
                                    simDeliveryAddress.html(cityExh[selectedExh].address);
                                }

                            }
                        });

                        addressCity.on('change', function (e) {
                            simFactory.setCity($(this).val());
                            $.each(_me.find('[name="delivery_method"]'), function () {
                                this.checked = false;
                            });

                            exhibitions.empty();
                            exhibitions.val('');
                            simDeliveryAddress.empty();
                            exhibitions.attr('required', true)
                            exhibitions.parents('.choose-exhibition').removeClass('display');
                            if (typeof application.oss.exhibitions[$(this).val()] !== 'undefined' && typeof application.oss.exhibitions[$(this).val()].exhibitions !== 'undefined' && Object.keys(application.oss.exhibitions[$(this).val()].exhibitions).length) {
                                exhibitions.parents('.custom-select-wrapper').css('display', 'block');
                                exhibitions.append(`<option value="">${application.oss.translations.oss_form.choose_exhibition}</option>`);
                                $.each(application.oss.exhibitions[$(this).val()].exhibitions, function (key, exhibition) {
                                    exhibitions.append(`<option value="${key}" data-address="${exhibition.address}">${exhibition.label}</option>`)
                                });
                                _me.find('#delivery-method-exhibition').parent().css('display', 'block');
                            } else {
                                exhibitions.parents('.custom-select-wrapper').css('display', 'none');
                                _me.find('#delivery-method-exhibition').parent().css('display', 'none')
                            }

                            makeSelect(exhibitions, 'reset');
                        })

                    }

                    // simFactory.openConfirmationForm();
                },
                onStepChanging: function (event, currentIndex, newIndex) {
                    if (newIndex < currentIndex) {
                        return true;
                    } else {
                        return validateWizard(currentIndex, newIndex);
                    }
                    currentStepIndex = currentIndex;
                    return true;
                },
                onStepChanged: function (event, currentIndex, priorIndex) {
                    onStepChanged(formWizard, currentIndex)

                    getEverythingReady(currentIndex, priorIndex);
                    currentStepIndex = currentIndex;
                    setWidth();
                },

                onFinished: function (event, currentIndex) {
                    currentStepIndex = currentIndex;
                    const valid = validateWizard(currentIndex);
                    if (!valid) {
                        return false;
                    }
                    if (isSubmitting) {
                        return false;
                    }
                    setWidth();

                    $(this).find('button').attr('disabled', true);
                    $(this).find('.wizard--loader').stop().fadeIn('fast');
                    isSubmitting = true;

                    if (application.oss.urls.validate_before_submit.length === 0) {
                        simFactory.reserveSims($('form#reserve-sim'), {
                            ProcessForm: (_requestForm) => {
                            },
                            onFailed: () => {
                                isSubmitting = false;

                                $(this).find('.wizard--loader').stop().fadeOut('fast');
                                const sectionWithError = formWizard.find('.error-name').first().parents('section');
                                $(this).find('button').attr('disabled', false);
                                if (sectionWithError.length && sectionWithError.data('index') !== currentIndex) {
                                    formWizard.steps("setStep", sectionWithError.data('index'));
                                }
                            },
                            onSuccess: (response) => {
                                isSubmitting = false;
                                $(this).find('.wizard--loader').stop().fadeOut('fast');
                                $(this).find('button').attr('disabled', false);
                                console.log('response', response)
                            },

                        });

                        return false;
                    }
                    simFactory.validateRequest($('form#reserve-sim'), {
                        onFailed: () => {
                            isSubmitting = false;
                            $(this).find('.wizard--loader').stop().fadeOut('fast');
                            const sectionWithError = formWizard.find('.error-name').first().parents('section');
                            $(this).find('button').attr('disabled', false);

                            $.each(formWizard.find('.g-recaptcha-manual'), function (idx, el) {
                                window.grecaptcha.reset($(el).data('grecaptcha_id'));
                            });

                            if (sectionWithError.length && sectionWithError.data('index') !== currentIndex) {
                                formWizard.steps("setStep", sectionWithError.data('index'));
                            }

                        },
                        onSuccess: (response) => {
                            $.each(formWizard.find('.g-recaptcha-manual'), function (idx, el) {
                                window.grecaptcha.reset($(el).data('grecaptcha_id'));
                            });

                            isSubmitting = false;
                            $(this).find('.wizard--loader').stop().fadeOut('fast');
                            // $(this).find('button').attr('disabled', false);

                            let reviewRecaptchaWidgetId = '';
                            let recaptchaValue = '';


                            return $.alert({
                                title: '',
                                columnClass: 'column is-7 col-pull-3',
                                content: `
                                <div class="confirm-content">
                                    <div class="confirm-div">
                                        ${response.review_request}
                                    </div>
                                                                        
                                </div>
                                `,
                                onContentReady: function () {
                                    var jc1 = this;
                                    if (this.$content.find('#recaptcha-confirmation').length) {
                                        jc1.buttons.confirm_order.disable();
                                        reviewRecaptchaWidgetId = RenderRecaptcha(this.$content.find('#recaptcha-confirmation')[0], function (response) {
                                            jc1.buttons.confirm_order.enable();
                                            recaptchaValue = response;
                                            // console.log('recaptchaValue',recaptchaValue)
                                        });
                                    }

                                },
                                buttons: {
                                    confirm_order: {
                                        text: application.oss.translations.oss_form.confirm_order,
                                        btnClass: 'main-btn',
                                        action: function () {
                                            var jc = this;
                                            jc.showLoading();
                                            jc.buttons.confirm_order.disable();
                                            jc.buttons.cancel.disable();

                                            simFactory.reserveSims($('form#reserve-sim'), {
                                                ProcessForm: (_requestForm) => {
                                                    if (!_requestForm.find('#g-recaptcha-response').length) {
                                                        _requestForm.append(`<textarea id="g-recaptcha-response" name="g-recaptcha-response" class="g-recaptcha-response" style="display: none !important;resize: none; display: none;padding: 0;" ></textarea>`);
                                                    }

                                                    // recaptchaValue = window.grecaptcha.getResponse(reviewRecaptchaWidgetId);
                                                    _requestForm.find('#g-recaptcha-response').val(recaptchaValue);

                                                },
                                                onFailed: () => {
                                                    recaptchaValue = '';
                                                    if (typeof window.grecaptcha !== 'undefined') {
                                                        jc.buttons.confirm_order.disable();
                                                        window.grecaptcha.reset(reviewRecaptchaWidgetId);
                                                    } else {
                                                        jc.buttons.confirm_order.enable();
                                                    }
                                                    isSubmitting = false;
                                                    $(this).find('.wizard--loader').stop().fadeOut('fast');
                                                    const sectionWithError = formWizard.find('.error-name').first().parents('section');
                                                    $(this).find('button').attr('disabled', false);
                                                    if (sectionWithError.length && sectionWithError.data('index') !== currentIndex) {
                                                        formWizard.steps("setStep", sectionWithError.data('index'));
                                                    }
                                                    jc.hideLoading();
                                                    jc.buttons.confirm_order.disable();
                                                    this.buttons.cancel.enable();
                                                },
                                                onSuccess: () => {
                                                    recaptchaValue = '';

                                                    if (typeof window.grecaptcha !== 'undefined') {
                                                        jc.buttons.confirm_order.disable();
                                                        window.grecaptcha.reset(reviewRecaptchaWidgetId);
                                                    }
                                                    isSubmitting = false;
                                                    $(this).find('.wizard--loader').stop().fadeOut('fast');
                                                    $(this).find('button').attr('disabled', false);
                                                    jc.hideLoading();
                                                    jc.close();
                                                },

                                            });
                                            return false;
                                        }
                                    },
                                    cancel: {
                                        text: application.oss.translations.oss_form.cancel,
                                        btnClass: 'main-btn-gray',
                                        action: function () {

                                        }
                                    },
                                },
                            })
                        },

                    });

                    return false;
                },
            });

        });

        // $(window).on('legocms.uploading', function (event, isUploading) {
        //     console.log('isUploading',isUploading)
        // });
        $(window).on('legocms.uploading.failed', onUploadingFileFailed);

        $('body').on('click', '.terms-and-conditions-btn', function (e) {
            e.preventDefault();
            const content = $(this).closest('.terms-and-conditions-wrapper').find('.terms-and-conditions-content');
            if (!content.length) {
                return false;
            }
            const btn = $(this);
            let isAccepted = false;

            const _alert = successAlert(content.html(), {
                columnClass: 'column is-10 ',
                iconHtml: OoredooIcon('icon-Icon-161'),
                closeIcon: false,
                backgroundDismiss: true,
                // escapeKey: true,
                buttons: {
                    accept: {
                        text: 'الموافقة على الشروط',
                        action: function () {
                            isAccepted = true;
                            btn.find('#i_accept_terms')[0].checked = true;

                        }
                    }
                },
                onClose: function () {
                    btn.find('#i_accept_terms')[0].checked = isAccepted;
                },

            })
        });

    }
)(jQuery);
